module.exports = __webpack_public_path__ + "img/ttsMarket4.2055ad0f.png";